import { useState, useEffect } from "react";
import * as reportServices from "../../../services/reports.services";
import { useDispatch } from "react-redux";
import { logout } from "../../../slices/authSlice";
import { useTranslation } from "react-i18next";
import PageLoader from "../../../components/Loaders/PageLoader";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { format } from "date-fns";

const Table = ({ year, month, day, monthly }) => {
  const [activeUsers, setActiveUsers] = useState(null);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const { t } = useTranslation();
  let dispatch = useDispatch();

  const columns = [
    {
      name: t("code"),
      selector: (row) => (
        <div className="bg-gray-800 text-gray-50 px-3 py-1 rounded-md ">
          {row?.user?.code}
        </div>
      ),
      sortable: true,
      cellExport: (row) => {
        return row?.user?.code;
      },
    },
    {
      name: t("firstName"),
      selector: (row) => row?.user?.firstName,
      sortable: true,
      cellExport: (row) => {
        return row?.user?.firstName;
      },
    },
    {
      name: t("midName"),
      selector: (row) => row?.user?.midName,
      cellExport: (row) => {
        return row?.user?.midName;
      },
      sortable: true,
    },
    {
      name: t("userEmail"),
      selector: (row) => row?.user?.email,
      cellExport: (row) => {
        return row?.user?.email;
      },
    },

    {
      name: t("phoneNumber"),
      selector: (row) => (
        <>
          {row?.user?.phoneNumber === "" || row?.user?.phoneNumber === null ? (
            <div className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md">
              {t("noPhoneNumber")}
            </div>
          ) : (
            <div>{row?.user?.phoneNumber}</div>
          )}
        </>
      ),
      cellExport: (row) => {
        if (row?.user?.phoneNumber === "" || row?.user?.phoneNumber === null) {
          return t("noPhoneNumber");
        } else {
          return row?.user?.phoneNumber;
        }
      },
    },
    {
      name: t("createdAt"),
      selector: (row) => (
        <>
          {row.createdAt
            ? format(new Date(row.createdAt), "MMM d, y")
            : "not found"}
        </>
      ),
      sortable: true,
      cellExport: (row) => {
        if (row?.createdAt) {
          return format(new Date(row.createdAt), "MMM d, y");
        }
      },
    },
  ];

  const getActiveUsers = async (page) => {
    if (monthly) {
      try {
        const response = await reportServices.getActiveUsersListByMonth(
          year,
          month,
          page,
          limit
        );

        if (response.status === 200) {
          setActiveUsers(response.data.logs.rows);
          setCount(response.data.logs.count);
        }
      } catch (error) {
        if (error.response.status === 401) {
          dispatch(logout());
        }
      }
    } else {
      try {
        const response = await reportServices.getActiveUsersListByDay(
          year,
          month,
          day,
          page,
          limit
        );

        if (response.status === 200) {
          setActiveUsers(response.data.logs.rows);
          setCount(response.data.logs.count);
        }
      } catch (error) {
        if (error.response.status === 401) {
          dispatch(logout());
        }
      }
    }
  };

  const handlePageChange = (page) => {
    getActiveUsers(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    if (monthly) {
      try {
        const response = await reportServices.getActiveUsersListByMonth(
          year,
          month,
          page,
          newPerPage
        );
        setActiveUsers(response.data.logs.rows);
        setLimit(newPerPage);
        setLoading(false);
      } catch (error) {
        if (error.response.status === 401) {
          dispatch(logout());
        }
      }
    } else {
      try {
        const response = await reportServices.getActiveUsersListByDay(
          year,
          month,
          day,
          page,
          newPerPage
        );
        setActiveUsers(response.data.logss.rows);
        setLimit(newPerPage);
        setLoading(false);
      } catch (error) {
        if (error.response.status === 401) {
          dispatch(logout());
        }
      }
    }
  };

  useEffect(() => {
    getActiveUsers(1);
    // eslint-disable-next-line
  }, [year, month, day]);

  const tableData = {
    columns,
    data: activeUsers,
  };

  return (
    <div className="mt-4">
      {activeUsers ? (
        <DataTableExtensions
          {...tableData}
          filter={false}
          print={false}
          exportHeaders
        >
          <DataTable
            columns={columns}
            data={activeUsers}
            progressPending={loading}
            progressComponent={<PageLoader />}
            pagination
            paginationServer
            paginationTotalRows={count}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeader
            direction={
              window.localStorage.getItem("i18nextLng") === "en" ? "ltr" : "rtl"
            }
          />
        </DataTableExtensions>
      ) : (
        <PageLoader />
      )}
    </div>
  );
};

export default Table;
